/* @flow */
import { combineReducers } from 'redux';

import roleBasedMessagingSearch from 'reducers/roleBasedMessagingSearch';
import organizationClassesTables from 'reducers/organizationClassesTables';
import connectionStateBanner from 'reducers/connectionStateBanner';
import tables from 'reducers/tables';
import banners from 'reducers/banners';
import toasts from 'reducers/toasts';
import recentMessagesModal from 'reducers/recentMessagesModal';
import adminUpgradePage from 'admin/reducers/adminUpgradePage';
import peopleTables from 'reducers/peopleTables';
import schoolTables from 'reducers/schoolTables';
import phoneCalls from 'phoneCalls/reducers/phoneCalls';
import fileUploads from 'reducers/fileUploads';
import floatingBoxes from 'reducers/floatingBoxes';
import modals from 'reducers/modals';
import touch from 'reducers/touch';
import zopim from 'reducers/zopim';
import streamReadMarkerPush from 'reducers/StreamReadMarkerPush';
import creditCards from 'reducers/creditCards';
import directAddForm from 'reducers/directAddForm';

const globalReducers = {
  roleBasedMessagingSearch,
  connectionStateBanner,
  organizationClassesTables,
  adminUpgradePage,
  streamReadMarkerPush,
  schoolTables,
  banners,
  toasts,
  touch,
  modals,
  tables,
  floatingBoxes,
  recentMessagesModal,
  peopleTables,
  phoneCalls,
  fileUploads,
  zopim,
  creditCards,
  directAddForm,
};

export default function combineRemindReducers() {
  return combineReducers({
    ...globalReducers,
  });
}
